/**
 * Places the global promo into its fixed in-stream grid slot (same model as Grid promo blocks).
 * Clones from the header mount so filter AJAX can re-place it. Appends at the end of the
 * grid when the collection is too short to reach the configured slot.
 */
(function () {
  'use strict';

  var placing = false;
  var observedGrid = null;
  var observer = null;
  var observeTimer = null;

  function copyEditorAttributes(from, to) {
    if (!from || !to) return;
    Array.prototype.forEach.call(from.attributes, function (attr) {
      if (attr.name.indexOf('data-shopify') === 0) {
        to.setAttribute(attr.name, attr.value);
      }
    });
  }

  function getCollectionGrid() {
    return document.querySelector('.collection__products .js-grid[data-grid-large]');
  }

  function getGridEndAnchor(grid) {
    return grid.querySelector('[data-variant-card-placeholder]');
  }

  function isCountableGridItem(el, ignoreEl) {
    if (!el || el.nodeType !== 1 || el === ignoreEl) return false;
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEMPLATE') return false;
    if (el.hasAttribute('data-collection-promo-reservations')) return false;
    if (el.hasAttribute('data-global-promo-grid-slot')) return false;
    if (el.hasAttribute('data-global-collection-promo-slot')) return false;
    if (el.hasAttribute('data-variant-card-placeholder')) return false;
    return true;
  }

  function itemSpan(el, grid) {
    var span = el.getAttribute('data-promo-span');
    if (span === 'full' || el.classList.contains('js-grid__full-row')) {
      return parseInt(grid.getAttribute('data-grid-large') || '4', 10) || 4;
    }
    if (span === '2' || el.classList.contains('collection-promo-slot--two')) return 2;
    return 1;
  }

  function findInsertBefore(grid, targetStart, ignoreEl) {
    var pos = 1;
    var children = grid.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (!isCountableGridItem(el, ignoreEl)) continue;
      if (pos >= targetStart) return el;
      pos += itemSpan(el, grid);
    }
    return null;
  }

  function appendToGridEnd(grid, slot) {
    var anchor = getGridEndAnchor(grid);
    if (anchor) {
      if (slot.nextSibling === anchor) return;
      grid.insertBefore(slot, anchor);
      return;
    }
    if (slot.parentNode === grid && slot === grid.lastElementChild) return;
    grid.appendChild(slot);
  }

  function clonePromoContent(mount) {
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(mount.children, function (child) {
      var clone = child.cloneNode(true);
      if (clone.id) clone.removeAttribute('id');
      if (clone.querySelectorAll) {
        Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) {
          el.removeAttribute('id');
        });
      }
      frag.appendChild(clone);
    });
    return frag;
  }

  function buildSlot(mount) {
    if (!mount.children.length) return null;

    var widthKey = mount.getAttribute('data-width') || 'two';
    var slot = document.createElement('div');
    slot.className = 'collection-promo-slot';
    slot.setAttribute('data-collection-promo-slot', '');
    slot.setAttribute('data-global-collection-promo-slot', '');
    slot.setAttribute('data-promo-grid-start', mount.getAttribute('data-grid-start') || '17');

    if (widthKey === 'two') {
      slot.classList.add('collection-promo-slot--two');
      slot.setAttribute('data-promo-span', '2');
    } else if (widthKey === 'full') {
      slot.classList.add('js-grid__full-row');
      slot.setAttribute('data-promo-span', 'full');
    } else {
      slot.classList.add('collection-promo-slot--one');
      slot.setAttribute('data-promo-span', '1');
    }

    copyEditorAttributes(mount, slot);
    slot.appendChild(clonePromoContent(mount));
    return slot;
  }

  function insertSlot(grid, slot, mount) {
    var slotTarget = grid.querySelector('[data-global-promo-grid-slot]');
    if (slotTarget) {
      slot.removeAttribute('data-global-promo-fallback');
      slotTarget.replaceWith(slot);
      return;
    }

    var targetStart = parseInt(mount.getAttribute('data-grid-start') || '17', 10) || 17;
    var insertBefore = findInsertBefore(grid, targetStart, slot);
    if (insertBefore) {
      slot.removeAttribute('data-global-promo-fallback');
      if (slot.parentNode === grid && slot.nextSibling === insertBefore) return;
      grid.insertBefore(slot, insertBefore);
      return;
    }

    slot.setAttribute('data-global-promo-fallback', '');
    appendToGridEnd(grid, slot);
  }

  function placeGlobalCollectionPromo(options) {
    if (placing) return;
    if (!document.body.classList.contains('template-collection')) return;

    var refresh = options && options.refresh;
    var mount = document.querySelector('[data-global-collection-promo-mount]');
    if (!mount) return;

    var grid = getCollectionGrid();
    if (!grid) return;

    var existing = grid.querySelector('[data-global-collection-promo-slot]');
    if (existing) {
      placing = true;
      if (refresh && mount.children.length) {
        existing.innerHTML = '';
        existing.appendChild(clonePromoContent(mount));
        copyEditorAttributes(mount, existing);
      }
      insertSlot(grid, existing, mount);
      placing = false;
      return;
    }

    var slot = buildSlot(mount);
    if (!slot) return;

    placing = true;
    insertSlot(grid, slot, mount);
    placing = false;
    document.dispatchEvent(new CustomEvent('theme:global-collection-promo:placed'));
  }

  function observeProductsGrid() {
    var productsGrid = document.querySelector('[data-products-grid]');
    if (!productsGrid || typeof MutationObserver === 'undefined') return;
    if (observedGrid === productsGrid) return;

    if (observer) observer.disconnect();
    observedGrid = productsGrid;
    observer = new MutationObserver(function () {
      if (placing) return;
      clearTimeout(observeTimer);
      observeTimer = setTimeout(placeGlobalCollectionPromo, 80);
    });
    observer.observe(productsGrid, { childList: true, subtree: true });
  }

  function init(refresh) {
    placeGlobalCollectionPromo({ refresh: !!refresh });
    observeProductsGrid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(false);
    });
  } else {
    init(false);
  }

  document.addEventListener('shopify:section:load', function () {
    init(true);
  });
  document.addEventListener('shopify:section:unload', function () {
    init(true);
  });
  document.addEventListener('theme:resize:width', function () {
    init(false);
  });
  document.addEventListener('theme:variant-infinite-scroll:loaded', function () {
    init(false);
  });
})();
